import { BRAND_COLORS } from "@/lib/brandColors";
import { useMedia } from "tamagui";

export const PERSONAL_HUB = {
  sectionTitle: "For you",
  panelRadius: 16,
  panelBorder: "rgba(0,0,0,0.06)",
  panelShadow: "0 4px 24px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.04)" as const,
  tileRadius: 10,
  tileBg: "rgba(244, 241, 237, 0.55)",
  emphasisBg: "rgba(253, 233, 219, 0.22)",
  tileMinHeight: 80,
  accentSoft: "#FDE9DB",
  setupPanelBg: "#FFFBF8",
  gap: 8,
  thumbMobile: 44,
  thumbDense: 40,
  landscapeThumbMobile: 104,
  landscapeThumbTablet: 116,
  landscapeThumbDesktop: 124,
  mobileRailWidth: 220,
} as const;

export function useLandscapeThumbWidth(): number {
  const media = useMedia();
  if (media.gtMd) return PERSONAL_HUB.landscapeThumbDesktop;
  if (media.gtSm) return PERSONAL_HUB.landscapeThumbTablet;
  return PERSONAL_HUB.landscapeThumbMobile;
}

export const HUB_COPY = {
  continue: { eyebrow: "Continue watching", cta: "Resume" },
  dashboard: { eyebrow: "Your dashboard", updateCta: "Update dashboard" },
  setup: {
    eyebrow: "Get started",
    title: "Set your dashboard",
    subtitle: "Choose your instrument and skill level",
  },
  purchased: {
    eyebrow: "Your library",
    title: "Purchased courses",
    countLabel: (n: number) => (n === 1 ? "1 course" : `${n} courses`),
  },
} as const;

export { BRAND_COLORS };
